import React, { useEffect, useRef, useState, useCallback } from 'react'
import withTranslator from '../../HOCComponents/withTranslator'
import isEmpty from 'lodash/isEmpty'
import ScreenshotImage from '../../ModalComponents/SendFieldsReportModal/ScreenshotImage'
import { StyledSampleIconButton } from './SampleForm'
import { captureException } from '@sentry/browser'
import { createHemavError, ERROR_CODES } from '../../../helpers/errors/errorHelper'

const screenshotStyle = {
  width: '50%',
  margin: 0
}

function SampleImageUpload({ t, picturePath, onChange, getS3Url, isNewSampleMode, resetSampleFormPicturePath }) {
  const isVisible = !isEmpty(picturePath)
  const fileInputRef = useRef(null)
  const [src, setSrc] = useState('')

  const handleButtonClick = () => fileInputRef.current.click()

  function handleFileInputChange(event) {
    const file = event.target.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      const base64Data = reader.result
      onChange(base64Data)
    }
    // eslint-disable-next-line
    reader.onerror = function (error) {
      // logic for error
    }
  }

  const handleS3Error = useCallback(
    (error, pictureS3Url) => {
      console.log('Failed to fetch S3 URL for image:', error)
      captureException(
        createHemavError({
          code: ERROR_CODES.ERROR_FETCHING_S3_URL,
          message: `Failed to getS3Url for in SampleImageUpload: ${error?.message || error || 'unknown error'}`
        }),
        {
          tags: {
            errorType: ERROR_CODES.ERROR_FETCHING_S3_URL,
            component: 'SampleImageUpload',
            operation: 'getS3Url'
          },
          extra: { picturePath, pictureS3Url, isNewSampleMode }
        }
      )
      setSrc('')
    },
    [picturePath, isNewSampleMode]
  )

  useEffect(() => {
    if (!picturePath) {
      setSrc('')
      return
    }

    // If picturePath is base64 data, use it directly
    if (picturePath.startsWith('data:')) {
      setSrc(picturePath)
      return
    }

    // Otherwise, it's a file path that needs S3 URL
    getS3Url(picturePath)
      .then(({ url }) => {
        setSrc(url)
      })
      .catch(error => {
        handleS3Error(error, null)
      })
  }, [picturePath, getS3Url, isNewSampleMode, handleS3Error])

  const removeScreenshot = () => {
    setSrc('')
    resetSampleFormPicturePath()
  }

  if (isVisible) {
    return <ScreenshotImage hideTitle style={screenshotStyle} removeScreenshot={removeScreenshot} activeScreenshot={src} onError={handleS3Error} />
  }

  return (
    <StyledSampleIconButton hasValue={isVisible} title={t('add photo')} icon={'fas fa-camera'} onClick={handleButtonClick}>
      <input type="file" accept="image/*" style={{ display: 'none' }} ref={fileInputRef} onChange={handleFileInputChange} />
    </StyledSampleIconButton>
  )
}

export default withTranslator(SampleImageUpload)
